import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMTitleCard } from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { getItemName } from "../../../utils/get-plural-of-item-name";
import { getProjectStatusBadge } from "../../../utils/get-project-status-badge";
import { makeGetCardCopy } from "../card-copy";

export function addTrackingItemsTitleCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";
  const getCardCopy = makeGetCardCopy(app);

  const trackingItemsTitleComponent = view.addComponent({
    component: PMTitleCard,
    layoutProps: {
      componentId: "trackingItemsTitleComponent",
      labels: ["report-title"],
      title: getCardCopy(language, "reportTrackingItemsTitle").title,
      description: getCardCopy(language, "reportTrackingItemsTitle")
        .description,
    },
  });

  trackingItemsTitleComponent.mapState(({ currentReport, settings }) => {
    return {
      title: `${getItemName(settings?.configuration?.itemName, language)}: ${
        currentReport?.project?.customId
          ? currentReport.project.customId + " - "
          : ""
      }${currentReport?.project?.name ?? ""}`,
      badgeConfigs: [
        getProjectStatusBadge({
          currentReport,
          reportingCycle: settings?.configuration?.reportingCycle,
          language: language || "en",
        }),
      ],
    };
  });
}
